import { useContext, useState, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context';
import Table from '../../../components/Table';
import Button from '../../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import CustomSelect from '../../../components/CustomSelect';
import { getLibraryEduLessons } from '../../../actions/library';

const GRADE_KEYS = ['grade0', 'grade1', 'grade2', 'grade3', 'grade4', 'grade5', 'grade6', 'grade7', 'grade8', 'grade9', 'grade10', 'grade11']
const CLASS_HEADERS = ['Оценка на момент пост.', '1 класс', '2 класс', '3 класс', '4 класс', '5 класс', '6 класс', '7 класс', '8 класс', '9 класс', '10 класс', '11 класс']

export default function FinalGrades() {
  const dispatch = useDispatch()

  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)
  const { eduLessons } = useSelector(state => state.library)

  const { values, setFieldValue, setValues } = allForms

  const { grades: gradesData } = studentTabData || {}

  const lastSyncedRef = useRef(null)

  const [selectedRow, setSelectedRow] = useState(null)
  const [addSubject, setAddSubject] = useState('')
  const [period, setPeriod] = useState('Год')

  useEffect(() => {
    if (!eduLessons?.length) dispatch(getLibraryEduLessons())
  }, []) // eslint-disable-line

  useEffect(() => {
    const dataJson = JSON.stringify(gradesData)
    if (!addMode && gradesData && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        grades: [...gradesData]
      }))
      if (updateInitialValues) {
        updateInitialValues('grades', gradesData)
      }
    }
  }, [gradesData, addMode, setValues, updateInitialValues])

  const handleAdd = () => {
    if (!addSubject) return
    const lesson = (eduLessons || []).find(l => String(l.id || l.lid) === String(addSubject))
    const newRow = {
      lid: lesson ? (lesson.id || lesson.lid) : addSubject,
      predmet: lesson ? lesson.name : '',
      grade0: '', grade1: '', grade2: '', grade3: '', grade4: '', grade5: '',
      grade6: '', grade7: '', grade8: '', grade9: '', grade10: '', grade11: '',
      id: `new_${Date.now()}`
    }
    setFieldValue('grades', [...(values.grades || []), newRow])
    setAddSubject('')
  }

  const handleDelete = () => {
    const items = values.grades || []
    if (selectedRow !== null && items[selectedRow]) {
      const filtered = items.filter((_, idx) => idx !== selectedRow)
      setFieldValue('grades', filtered)
      setSelectedRow(null)
    }
  }

  const periodOptions = [
    { name: 'Год', value: 'Год' },
  ]

  const subjectOptions = (eduLessons || []).map(l => ({
    name: l.name,
    value: String(l.id || l.lid)
  }))

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <Table className={styles.table}>
          <thead>
            <tr>
              <th>Предмет</th>
              {CLASS_HEADERS.map(h => <th key={h} style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {(values.grades || []).map((item, idx) => (
              <tr
                key={item.lid || item.id || idx}
                onClick={() => setSelectedRow(idx)}
                style={{ cursor: 'pointer', backgroundColor: selectedRow === idx ? '#DEECFF' : 'transparent' }}
              >
                <td>{item.predmet || ''}</td>
                {GRADE_KEYS.map(key => (
                  <td key={key} style={{ textAlign: 'center' }}>{item[key] || ''}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow} style={{ justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
            <CustomSelect
              title='Добавить предмет на момент поступления'
              valuesName='addSubject'
              value={addSubject}
              options={subjectOptions}
              width={300}
              setFieldValue={(_, v) => setAddSubject(v)}
              withoutAll
            />
            <CustomSelect
              title='Учебный период'
              valuesName='period'
              value={period}
              options={periodOptions}
              width={120}
              setFieldValue={(_, v) => setPeriod(v)}
              withoutAll
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
            <Button mode='bordered' onClick={handleAdd} disabled={!addSubject}>+ Добавить</Button>
            <Button mode='bordered' onClick={handleDelete} disabled={selectedRow === null}>✕ Удалить</Button>
          </div>
        </div>
      </div>
    </div>
  )
}
